import Vue from 'vue'

export async function getTarifas(context, [access_token, showload]) {
    try {
        
        if (showload){
          context.commit('setLoading', true, { root: true })
        }
        const response = await Vue.axios({
            method: 'GET',
            url: '/tarifas',
            headers: {
                //  'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            

        })
       
        context.commit('tar/setTarifas', response.data, { root: true })
    } catch (e) {
    } finally {
        if (showload){
            context.commit('setLoading', false, { root: true })
        }
    }
}



export async function updateTarifa(context, [access_token, tar]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'PATCH',
            url: '/tarifas/' + tar.id,
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                tarifa: tar,
               
            }
        })
      
        if (response.status == 200) {
            context.commit('tar/actListTarifas', response.data, { root: true })
            return response.data
        }
    } catch (e) {
      
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}




export async function createTarifa(context, [access_token, tar]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/tarifas',
            headers: {
                //'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
               
                tarifa: tar,
               
                
            }
        })
        if (response.status == 200) {
          //  context.commit('act/actListActividades', response.data, { root: true })
            return response.data
        }
       
    } catch (e) {
        return null
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}



export async function deleteTarifa(context, [access_token, id]) {
    try {
        context.commit('setLoading', true, { root: true })
        const response = await Vue.axios({
            method: 'POST',
            url: '/tarifadelete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: {
                id: id,
            }
        })

        if (response.status == 201) {
            context.commit('tar/actDeleteListTarifas', id, { root: true })
            return response;
        }
       
    } catch (e) {
       return null
    } finally {
        context.commit('setLoading', false, { root: true })
    }
}